import React from 'react';
import Disclaimer from 'components/AdvertiserToolTip';
import PageLoadingMask from 'components/masks/PageLoadingMask';
import { SectionContainer } from 'components/Containers/SectionContainer/SectionContainer';
import { Row } from 'components/Containers/Row/Row';
import LifeInsuranceFilters from './components/LifeInsuranceFilters/index';
import { useViewModule } from 'hook/helper.hook';
import { getViewModuleTrackingAttributes } from 'helpers/tracking.helpers';
import { LIFE_INSURANCE } from 'types/morph.pagePosition.constants';
import { LIFE_INSURANCE_VERTICAL } from 'types/marketplaceTiles.constants';
import LifeInsuranceOfferView from './components/LifeInsuranceOfferView';
import './LifeInsuranceModule.style.scss';

export const LifeInsuranceModuleView = props => {
  const { modulePosition, seenPixel } = props;
  useViewModule(
    getViewModuleTrackingAttributes({
      pagePosition: LIFE_INSURANCE,
      modulePosition,
      vertical: LIFE_INSURANCE_VERTICAL,
    }),
  );

  return (
    <>
      {seenPixel}
      <Row className="flex-container justify-end padR0 margB8 m-padR16 padL0 mobilePad16">
        <Disclaimer showPartnerText />
      </Row>
      <SectionContainer className="new-life-insurance-marketplace">
        <LifeInsuranceFilters {...props} />
        <LifeInsuranceOfferView {...props} moduleName={LIFE_INSURANCE} />
      </SectionContainer>
    </>
  );
};

export const LoadingView = PageLoadingMask;
